import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar-sticky" }
const _hoisted_3 = { class: "page-bar page-bar-toggles-wrap" }
const _hoisted_4 = { class: "page-bar-toggles" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rocks_view = _resolveComponent("rocks-view")!
  const _component_personal_goals_view = _resolveComponent("personal-goals-view")!
  const _component_scorecard_view = _resolveComponent("scorecard-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "page-bar" }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", { class: "page-bar-sub" }, "Foundations"),
          _createElementVNode("div", { class: "page-bar-main" }, "Scoreboard")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.tab == 'scoreboard' ? 'page-bar-toggle-s' : ''),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab('scoreboard')))
          }, "Scorecard", 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.tab == 'rocks' ? 'page-bar-toggle-s' : ''),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab('rocks')))
          }, "Rocks", 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.tab == 'goals' ? 'page-bar-toggle-s' : ''),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab('goals')))
          }, "Personal Goals", 2)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.tab == 'rocks')
        ? (_openBlock(), _createBlock(_component_rocks_view, { key: 0 }))
        : (_ctx.tab == 'goals')
          ? (_openBlock(), _createBlock(_component_personal_goals_view, { key: 1 }))
          : (_openBlock(), _createBlock(_component_scorecard_view, { key: 2 }))
    ], 2)
  ]))
}